import { render, staticRenderFns } from "./backAdminSet.vue?vue&type=template&id=1e4496a2"
import script from "./backAdminSet.vue?vue&type=script&lang=js"
export * from "./backAdminSet.vue?vue&type=script&lang=js"
import style0 from "./backAdminSet.vue?vue&type=style&index=0&id=1e4496a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports